import { Link } from 'react-router-dom';

/**
 * props:
 * - to: /settings
 * - text: Settings
 * - disabled: boolean (opcional)
 * - style: object (opcional)
 */
function SideBarItem(props) {

    function getClassName(itemName) {
        const path = window.location.pathname;
        const active = props.matchPrefix
            ? path === itemName || path.startsWith(`${itemName}/`)
            : path === itemName;
        return active ? 'nav-item active' : 'nav-item';
    }

    const linkStyle = props.disabled 
        ? { 
            color: 'rgba(255,255,255,0.4)', 
            cursor: 'not-allowed',
            ...props.style 
        }
        : props.style;

    return (
        <li className={getClassName(props.to)}>
            <Link 
                to={props.disabled ? "#" : props.to} 
                className="nav-link" 
                onClick={props.onClick}
                style={linkStyle}
            >
                <span className="sidebar-icon">
                    {props.children}
                </span>
                <span className="sidebar-text">{props.text}</span>
            </Link>
        </li>
    );
}

export default SideBarItem;